import Papa from "papaparse";
import { saveAs } from "file-saver";


const downloadCSV = (data, filename) => {
    const csv = Papa.unparse(data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, filename);
};

export default downloadCSV;